import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';

import { SheetDragDirection, SheetHandleComponent } from './sheet-handle.component';

/**
 * Hoja persistente, la del seguimiento: vive en la página, encima del mapa, abierta o colapsada, sin velo y
 * con el mapa vivo debajo. Lo proyectado con `uiSheetSummary` se ve siempre; el resto queda `inert` al
 * colapsar, para que el tabulador no entre a lo que no se ve.
 *
 * Es propia porque esto no es lo que hace `ion-modal`, que es un overlay. Para una hoja que sí tape la
 * pantalla, `ui-modal-sheet`. El padre debe ser `position: relative`.
 */
@Component({
  selector: 'ui-bottom-sheet',
  imports: [SheetHandleComponent],
  template: `
    <section
      class="panel"
      role="region"
      [class.open]="open()"
      [attr.aria-label]="label()"
      [style.--ui-sheet-open-height]="openHeight()"
      [style.--ui-sheet-collapsed-height]="collapsedHeight()"
      (keydown.escape)="open.set(false)"
    >
      <ui-sheet-handle
        class="handle"
        [expanded]="open()"
        [label]="handleLabel()"
        (tapped)="open.set(!open())"
        (dragged)="onDrag($event)"
      />
      <div class="summary"><ng-content select="[uiSheetSummary]" /></div>
      <div class="content" [attr.inert]="open() ? null : ''"><ng-content /></div>
    </section>
  `,
  styleUrl: './bottom-sheet.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomSheetComponent {
  readonly label = input.required<string>();
  readonly open = model(false);
  /** En rem para crecer con el texto. El tope real lo pone el CSS: nunca más que la pantalla. */
  readonly openHeight = input('27.25rem');
  readonly collapsedHeight = input('7rem');

  protected readonly handleLabel = computed(() => (this.open() ? 'Colapsar hoja' : 'Expandir hoja'));

  protected onDrag(direction: SheetDragDirection): void {
    this.open.set(direction === 'up');
  }
}
